import { PhoneMaskProcessing } from './phone';

export class PhoneExtMaskProcessing extends PhoneMaskProcessing {
  protected fixedPosGroupingChars = ['(', null, null, null, ')', ' ', null, null, null, '-', null, null, null, null, ' ', 'x'];
  protected maxLength = 20;
}
